import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=13a89bc3&scoped=true"
import script from "./rules.vue?vue&type=script&lang=js"
export * from "./rules.vue?vue&type=script&lang=js"
import style1 from "./rules.vue?vue&type=style&index=1&id=13a89bc3&prod&scoped=true&lang=css"
import style2 from "./rules.vue?vue&type=style&index=2&id=13a89bc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a89bc3",
  null
  
)

export default component.exports